import { HttpErrorResponse } from '@angular/common/http';
import { EmployeeIdentityDocumentStatus } from '../../_interfaces/employee.interface';

export function formatDateSlash(date: string | null) {
  if (!date) return '';
  return date.replaceAll('/', '-');
}

export function formatDateDash(date: string | null) {
  if (!date) return '';
  return date.replaceAll('-', '/');
}

export function handleOtpError(error: HttpErrorResponse) {
  let errorString: string = '';
  if (error.error.code.length > 0) {
    error.error.code.forEach((err: string) => {
      errorString = errorString + err + '\n';
    });
  }
  if (error.error.detail) {
    errorString = errorString + error.error.detail;
  }
  return errorString;
}

export function idStatus(status: EmployeeIdentityDocumentStatus | null) {
  return {
    isNull: status === null,
    isNew: status === EmployeeIdentityDocumentStatus.New,
    isVerified: status === EmployeeIdentityDocumentStatus.Verified,
    isRejected: status === EmployeeIdentityDocumentStatus.Rejected,
    isError: status === EmployeeIdentityDocumentStatus.Error,
  };
}

/**
 * Calculate pagination display values (e.g., "Showing 1 to 9 of 11")
 * @param pageOffset - Zero-based page offset (page 1 = 0, page 2 = 1)
 * @param pageSize - Number of items per page
 * @param totalCount - Total number of items
 * @returns Object with rowNumber (start) and totalShown (end)
 */
export function calcShowPage(
  pageOffset: number,
  pageSize: number,
  totalCount: number,
): { rowNumber: number; totalShown: number } {
  const rowNumber = pageOffset * pageSize + 1;
  const pageOffsetTotal = pageOffset * pageSize + pageSize;
  const totalShown = Math.min(pageOffsetTotal, totalCount);

  return { rowNumber, totalShown };
}

/**
 * Formats a duration in seconds as a human-readable "Xh Ym Zs" string,
 * e.g. 1867 -> "31m 7s", 3661 -> "1h 1m 1s", 45 -> "45s".
 * Omits any unit whose value is 0, except when the total is 0 seconds.
 */
export function formatDuration(totalSeconds: number): string {
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = Math.floor(totalSeconds % 60);

  const parts: string[] = [];
  if (hours > 0) parts.push(`${hours}h`);
  if (minutes > 0) parts.push(`${minutes}m`);
  if (seconds > 0 || parts.length === 0) parts.push(`${seconds}s`);

  return parts.join(' ');
}
